import React, { FC } from 'react'
import { Flex, Box } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { Checkbox } from '@moonpig/launchpad-forms'
import { useIsMobile } from '@moonpig/web-shared-utils'
import {
  FilterCategory as FilterCategoryType,
  FilterItem,
} from '../../../../services/types/services'
import { mapFilterItem } from '../../../../utils/GalleryFiltering/mappings'
import { AccordionContent, AccordionHeading } from '../AccordionMenu'
import { DesktopDropdownItem } from './DropDownItem'
import { TopLevelFilterButton } from '../TopLevelFilterButton'

const StyledAccordionLabel = styled.label<{ hasSelectedChildren: boolean }>`
  pointer-events: none;
  ${({ hasSelectedChildren }) =>
    s({
      typography: 'typeBodyText',
      color: 'colorTextLabel',
      fontWeight: hasSelectedChildren ? 'bold' : /* istanbul ignore next */ 300,
    })}
`

type Props = {
  filter: FilterCategoryType
  onClick: (filter: FilterCategoryType | FilterItem, select?: boolean) => void
  level: number
  isDropdown?: boolean
}

export const FilterCategory: FC<Props> = ({
  filter,
  level,
  onClick,
  isDropdown = false,
}) => {
  const [accordionExpanded, setAccordionExpanded] = React.useState(false)
  const isMobile = useIsMobile()

  const handleCheckboxClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (filter.isSelected || accordionExpanded) {
      e.stopPropagation()
      return
    }
    setAccordionExpanded(true)
  }

  if (level === 0) {
    return <TopLevelFilterButton filter={filter} onClick={onClick} />
  }

  return (
    <AccordionContent
      heading={
        <AccordionHeading
          onClick={() => setAccordionExpanded(!accordionExpanded)}
        >
          <Flex flexDirection="row" alignItems="center">
            <Box onClick={handleCheckboxClick}>
              <Checkbox
                onChange={() => onClick(filter, !filter.isSelected)}
                checked={!!filter.isSelected}
                value={filter.id}
                id={filter.id}
                indeterminate={filter.hasSelectedChildren && !filter.isSelected}
              />
            </Box>
            <StyledAccordionLabel
              htmlFor={filter.id}
              hasSelectedChildren={filter.hasSelectedChildren}
            >
              <span>{filter.label}</span>
            </StyledAccordionLabel>
          </Flex>
        </AccordionHeading>
      }
      value={filter.label}
    >
      {filter.children?.map(filterItem =>
        isDropdown && !isMobile ? (
          <DesktopDropdownItem
            filterItem={filterItem}
            onClick={onClick}
            level={level}
          />
        ) : (
          mapFilterItem({
            filterItem,
            onClick,
            level: level + 1,
            indentation: 8,
          })
        ),
      )}
    </AccordionContent>
  )
}
